/**
 * InfiniteScroll — 목록 끝의 '더보기' 자리를 **스크롤로 자동 로드**되게 바꾼다.
 *
 * 목록 아래에 있는 감시 대상(sentinel)이 화면에 들어오면 onLoad 를 부른다. 감시 대상은 보통
 * 기존 '더보기' 컨테이너를 그대로 쓴다 — 그 요소는 이미 "더 받을 게 있을 때만" 보이도록
 * 호출부가 토글하고 있어서, 더 받을 게 없으면(display:none) 교차 판정 자체가 일어나지 않는다.
 *
 * 사용:
 *   const ctl = $j.Ui.InfiniteScroll.attach('#maOrderMore', { onLoad: () => this.fetchList() });
 *   if (ctl) $('#maOrderMore').addClass('is-auto');   // 버튼 감추고 로딩표시로 (scss)
 *
 * ⚠ **null 을 돌려줄 수 있다** — IntersectionObserver 가 없는 환경이다. 그때는 아무것도 하지
 *   않으므로 호출부의 '더보기' 버튼이 그대로 폴백으로 남아야 한다. 반환값을 보고 화면을 바꿀 것.
 *
 * onLoad 는 **여러 번 불릴 수 있다.** 로딩 중 재진입 방지는 호출부가 한다(대개 이미 하고 있다 —
 * `if (this.state.loading) return;`). 여기서 자체 잠금을 두면 호출부의 실패·중단과 어긋난다.
 *
 * opts
 *   onLoad      화면에 들어왔을 때 부를 함수 (필수)
 *   rootMargin  미리 당겨오는 여유. 기본 '320px 0px' — 바닥에 닿기 전에 채워 끊김을 없앤다.
 *   root        목록이 스크롤되는 상자 요소(overflow:auto). 기본 null(=화면). 상자 안에서 스크롤되는 목록은
 *               이걸 줘야 rootMargin 이 그 상자 기준으로 먹는다(안 주면 상자 경계에서 잘려 바닥에 닿아야 불린다).
 *               2026-10-21 악덕알리미 체불 리스트(.b-scroll) 때 추가.
 */
export default class InfiniteScroll {
    attach(target, opts = {}) {
        const el = typeof target === 'string' ? document.querySelector(target) : target;
        if (!el || typeof opts.onLoad !== 'function') return null;
        if (typeof IntersectionObserver !== 'function') return null;   // 미지원 → 버튼 폴백
        if (el.dataset.infinite) return null;                          // 중복 부착 방어
        el.dataset.infinite = '1';

        const io = new IntersectionObserver((entries) => {
            for (const e of entries) {
                if (e.isIntersecting) { opts.onLoad(); break; }
            }
        }, { root: opts.root || null, rootMargin: opts.rootMargin || '320px 0px' });

        io.observe(el);

        return {
            /** 감시 중단 (모달로 목록을 덮는 동안 등) */
            pause:  () => io.unobserve(el),
            resume: () => io.observe(el),
            destroy() {
                io.disconnect();
                delete el.dataset.infinite;
            },
        };
    }
}
